export default __webpack_public_path__ + "static/media/saval.724ca411.svg";